import { Box } from '@material-ui/core'
import * as React from 'react'
import { ReactComponent as DesktopSidebarIllustration } from '../../assets/v3/desktop-sidebar.svg'

export const DesktopSidebar = (props: { className?: string }) => (
  <Box display={{ xs: 'none', md: 'block' }} style={{ background: '#F2F2F6', width: '50%' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '30px 75px',
      }}
    >
      <DesktopSidebarIllustration style={{ maxWidth: '100%', height: 'auto' }} />
    </div>
  </Box>
)
